import { createPortal } from 'react-dom';
import { useEffect, useRef, useState } from 'react';
import Modal from './Modal';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import EcoImg from 'eco-design/base/eco-img';

const B: React.FC = () => {
    const { t } = useLang('ats.B');
    const webpOrJpg = useWebpOrJpg('#smart-gateway-B');
    const [modalOpen, setModalOpen] = useState(false);
    const handleOpenModal = () => {
        setModalOpen(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_details',
            tab: t('btn'),
            button_name: t('btn'),
            __btn_id1: `${css.section} .btn`,
            __btn_id2: t('btn'),
            __btn_type: 'text',
        });
    };

    /** 动画 */
    const infoRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const desc = infoRef.current?.querySelector('.desc');
        const ani1 = AniContainer.create({
            triggerElement: infoRef.current,
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                desc?.classList.add('enter');
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    desc?.classList.remove('enter');
                }
            },
        });

        const btn = document?.querySelector('.smart-gateway-B .btn-ani .btn');
        const ani2 = AniContainer.create({
            triggerElement: infoRef.current,
            triggerHook: 1,
            offset: '70%',
            duration: '100%',
            onEnter: () => {
                btn?.classList.add('enter');
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    btn?.classList.remove('enter');
                }
            },
        });
        return () => {
            ani1.destroy?.();
            ani2.destroy?.();
        };
    }, []);

    return (
        <section
            className={`${css.section} smart-gateway-B GtmModuleData-section`}
            id="smart-gateway-B"
            data-section-id={'smart-gateway-B'}
            data-section-title={t('title')}
        >
            <EcoImg
                pc={webpOrJpg(
                    'https://websiteoss.ecoflow.com/upload/image/1760091466994/Frame%201612708402.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1760091483863/Frame%20(1).webp',
                )}
                h5={webpOrJpg(
                    'https://websiteoss.ecoflow.com/upload/image/1760091466699/Frame%201612707730.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1760091484082/Frame.webp',
                )}
            />
            <div className="info" ref={infoRef}>
                <p className="desc ani-1">{t('desc')}</p>
            </div>
            <div className="btn-ani">
                <span className="btn GtmModuleData-btn-text" onClick={handleOpenModal}>
                    {t('btn')}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 25 24" fill="none">
                        <path
                            d="M12.5 24C19.1274 24 24.5 18.6274 24.5 12C24.5 5.37258 19.1274 0 12.5 0C5.87258 0 0.5 5.37258 0.5 12C0.5 18.6274 5.87258 24 12.5 24Z"
                            fill="#3F68E0"
                        />
                        <path d="M8.125 12H16.875" stroke="white" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M12.5 7.625V16.375" stroke="white" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </span>
            </div>

            {modalOpen && createPortal(<Modal callback={() => setModalOpen(false)}></Modal>, document.body)}
        </section>
    );
};

export default B;
